function _typeof(obj){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj},_typeof(obj)}import isElectron from"./is-electron";var isNode="object"===("undefined"==typeof process?"undefined":_typeof(process))&&"[object process]"===process+""&&!process.browser,isBrowser=!isNode||isElectron;export var isBrowserMainThread=isBrowser&&"undefined"!=typeof document;export default isBrowser;
//# sourceMappingURL=is-browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/utils/is-browser.js
// module id = 1728
// module chunks = 0